/**
 * A row of dots that mirrors which child of a horizontally scrolling
 * container is currently in view, and lets clicking a dot scroll to it.
 * Used for the Group block's "Carousel on mobile" option.
 */
class CarouselDots extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    const targetSelector = this.dataset.target;
    const container = targetSelector ? document.querySelector(targetSelector) : null;
    if (!(container instanceof HTMLElement)) return;

    const slides = Array.from(container.children);
    const dots = Array.from(this.querySelectorAll('.carousel-dots__dot'));
    if (slides.length === 0 || dots.length === 0) return;

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        slides[index]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const index = slides.indexOf(/** @type {Element} */ (entry.target));
          if (index === -1) continue;
          dots[index]?.classList.toggle('is-active', entry.isIntersecting);
        }
      },
      { root: container, threshold: 0.6 }
    );

    for (const slide of slides) {
      this.#observer.observe(slide);
    }
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('carousel-dots')) {
  customElements.define('carousel-dots', CarouselDots);
}
